import { createAction, props } from '@ngrx/store';
import { MwLoadOptions } from 'app/models/load-options.model';
import { MwPayloadModel } from 'app/models/payload.model';
import { OrderModel, OrderApiModel } from 'app/models/order-api.model';

export const loadOrders = createAction(
  '[Orders] Load',
  props<{
    options: MwLoadOptions;
  }>()
);
export const loadOrdersSuccess = createAction(
  '[Orders] Load Success',
  props<{ payload: MwPayloadModel<OrderModel[]> }>()
);
export const loadOrdersFailed = createAction(
  '[Orders] Load Failed',
  props<{ err: any }>()
);

export const createOrder = createAction(
  '[Order] Create',
  props<{ payload: OrderApiModel }>()
);
export const createOrderSuccess = createAction(
  '[Order] Create Success',
  props<{ payload: OrderApiModel }>()
);
export const createOrderFailed = createAction(
  '[Order] Create Failed',
  props<{ err: any }>()
);

export const editOrder = createAction(
  '[Order] Edit',
  props<{ payload: OrderApiModel }>()
);
export const editOrderSuccess = createAction(
  '[Order] Edit Success',
  props<{ payload: OrderApiModel }>()
);
export const editOrderFailed = createAction(
  '[Order] Edit Failed',
  props<{ err: any }>()
);

export const deleteOrder = createAction(
  '[Order] Delete',
  props<{ payload: OrderApiModel }>()
);
export const deleteOrderSuccess = createAction('[Order] Delete Success');

export const deleteOrderFailed = createAction(
  '[Order] Delete Failed',
  props<{ err: any }>()
);
